if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.cardStyle = this.dataset.cardStyle;
      this.itemSize = this.dataset.itemSize;
      this.columnsDesktop = this.dataset.columnsDesktop;

      this.sliderInstance = false;

      const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
      mql.onchange = this.init.bind(this);
      this.init();
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
        this.initMobileButtons();
      } else {
        this.destroyMobileButtons();
        this.initSlider();
      }
    }

    initSlider() {
      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.Mousewheel],
        slidesPerView: 'auto',
        spaceBetween: 8,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        loop: false,
        threshold: 2,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          768: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView: this.itemSize == 'fixed' ? (this.columnsDesktop > 4 ? 4 : this.columnsDesktop) : 'auto',
          },
          1024: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? this.columnsDesktop > 6
                  ? this.columnsDesktop - 1
                  : this.columnsDesktop
                : 'auto',
          },
          1280: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView: this.itemSize == 'fixed' ? this.columnsDesktop : 'auto',
          },
        },
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }

    initMobileButtons() {
      if (this.mobileButtonsInitialized) return;
      
      // The swipe-mobile container is this element itself
      if (!this.classList.contains('swipe-mobile')) return;

      const nextButton = this.section.querySelector(this.selectors.nextEl);
      const prevButton = this.section.querySelector(this.selectors.prevEl);
      
      if (!nextButton || !prevButton) return;

      const getScrollAmount = () => {
        // Get the first visible card to calculate scroll amount
        const firstCard = this.sliderWrapper.querySelector('.swiper-slide');
        if (!firstCard) return this.clientWidth * 0.5;
        
        const cardWidth = firstCard.offsetWidth;
        const computedStyle = window.getComputedStyle(this.sliderWrapper);
        const gap = parseFloat(computedStyle.columnGap) || 0;
        
        // Determine number of visible cards based on viewport width
        const viewportWidth = window.innerWidth;
        let cardsToScroll = 2; // Default: 2 cards for < 574px
        
        if (viewportWidth >= 574 && viewportWidth < 768) {
          cardsToScroll = 3; // 3 cards for 574px - 767px
        }
        
        return (cardWidth * cardsToScroll) + (gap * (cardsToScroll - 1));
      };

      const handleNext = (e) => {
        e.preventDefault();
        const scrollAmount = getScrollAmount();
        this.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      };

      const handlePrev = (e) => {
        e.preventDefault();
        const scrollAmount = getScrollAmount();
        this.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      };

      nextButton.addEventListener('click', handleNext);
      prevButton.addEventListener('click', handlePrev);

      this.mobileButtonsInitialized = true;
      this.mobileNextHandler = handleNext;
      this.mobilePrevHandler = handlePrev;
    }

    destroyMobileButtons() {
      if (!this.mobileButtonsInitialized) return;

      const nextButton = this.section.querySelector(this.selectors.nextEl);
      const prevButton = this.section.querySelector(this.selectors.prevEl);
      
      if (nextButton && this.mobileNextHandler) {
        nextButton.removeEventListener('click', this.mobileNextHandler);
      }
      
      if (prevButton && this.mobilePrevHandler) {
        prevButton.removeEventListener('click', this.mobilePrevHandler);
      }

      this.mobileButtonsInitialized = false;
      this.mobileNextHandler = null;
      this.mobilePrevHandler = null;
    }
  }
  customElements.define('collection-list', CollectionList);
}
